<template>
  <div class="body">
    <!-- common -->
    <div class="common-page dark-theme">
      <div class="wrap">
        <a href="#">
          <h1 class="logo"><img src="../assets/images/common/ci-wavve.png" alt="wavve"/></h1>
        </a>
      </div>
      <div class="error-page">
        <img src="../assets/images/common/icon-error-74.png" alt="error"/>
        <p class="error-txt01">서비스 점검 중입니다.</p>
        <p class="error-txt02">잠시만 기다려 주세요.<br/>예상시간 : {{count}} 초</p>
      </div>
      <div class="loading-progress">
        <div class="spinner">
          <div class="loading"></div>
        </div>
      </div>
    </div>
    <!--// common -->
  </div>
</template>
<script>
import { getServiceLocation } from '@/common/utils/request'
import cookie from '@/common/utils/cookie'
import { SERVICE_LOCATION_KEY } from '@/common/resources/const'
import _ from 'lodash'
import { setServiceLocationInfo } from '@/common/utils/common'

export default {
  name: 'waitingService',
  data () {
    return {
      defaultCount: 60,
      count: 60,
      countTimer: null
    }
  },
  methods: {
    startCount () {
      this.count = this.defaultCount
      this.countTimer = setInterval(() => {
        this.count -= 1
        if (this.count < 1) {
          this.checkServiceLocation()
          clearInterval(this.countTimer)
        }
      }, 1000)
    },
    checkServiceLocation () {
      getServiceLocation(cookie.getCredential()).then(({ data }) => {
        const isService = _.get(data, 'isservice', 'y') === 'y'
        if (isService) {
          setServiceLocationInfo(data)
          this.$router.replace('/')
        } else {
          this.startCount()
        }
      })
    }
  },
  created () {
    if (cookie.getCredential() === 'none') {
      sessionStorage.removeItem(SERVICE_LOCATION_KEY)
      this.$router.replace('/')
    } else {
      this.checkServiceLocation()
    }
  }
}
</script>
<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/base.css"></style>
<style lang="css" src="@/assets/css/main.css"></style>

<style scoped>
  .loading-progress {
    width: 80px;
    height: 80px;
  }
  .spinner {
    width: 80px;
    height: 80px;
    animation-iteration-count: infinite;
  }
  .loading{
    width: 80px;
    height: 80px;
    background: url(../assets/images/common/loading.png) no-repeat 0 0;
    background-size: cover;
    animation:box 1s steps(12) infinite;
  }
  @keyframes box {
    from {background-position:0 0}
    to   {background-position:-960px 0}
  }
</style>
